import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
export const GAMEPAD_CONTROL_CONSTANTS = {
    ZERO_THRESHOLD: 0.07,
    CHANGED_THRESHOLD: 0.01,
    COMMAND_REPEAT_THRESHOLD: 50,
    rightGasAxis: 2, //2
    leftGasAxis: 1, //1
    leftTurnAxis: 3, //3
    armSwitch: 5,
    cruiseSwitch: 4,
};
export const GamepadControl = ({ children, rightForwardCb, rightBackwardCb, leftForwardCb, leftBackwardCb, rightStopCb, leftStopCb, goCb, stopCb, turnCb, endTurnCb, onArmedStatusChanged, onControlTypeChanged, onRelayStateChanged, stickPositionsCb, }) => {
    let to = useRef();
    //const [axes, setAxes] = useState<number[]>([0,0,0,0,0,0,0,0,0,0]);
    let axes = useRef([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    let controlType = useRef(true);
    let isArmed = useRef(0);
    const { ZERO_THRESHOLD, CHANGED_THRESHOLD, COMMAND_REPEAT_THRESHOLD, rightGasAxis, leftGasAxis, leftTurnAxis, armSwitch, } = GAMEPAD_CONTROL_CONSTANTS;
    let commandCounter = useRef(0);
    let turnCommandCounter = useRef(0);
    let isTurnStopping = useRef(false);
    let lastTurnDirection = useRef(true);
    let lastTurnIsSpot = useRef(true);
    //const controlTypeSwitch = 6;
    const relaySwitches = [4, 6, 0, 7];
    const pollGamepad = useCallback(() => {
        const gamepads = navigator.getGamepads();
        const gp = gamepads.find((g) => g === null || g === void 0 ? void 0 : g.connected);
        //console.log(gamepads);
        if (gp) {
            // Работаем с первым подключённым геймпадом
            //console.log(gp);
            /*gp.axes.forEach((v, i) => {
                      if(Math.abs(v - axes.current[i]) > 0.01){
                          console.log(`Axis[${i}]: `, v);
                      }
                  });*/
            /*if(gp.axes[controlTypeSwitch] > ZERO_THRESHOLD){
                      //console.log(gp);
                      if(axes.current[controlTypeSwitch] < ZERO_THRESHOLD){
                          onControlTypeChanged(true);
                          controlType.current = true;
                          axes.current[controlTypeSwitch] = gp.axes[controlTypeSwitch];
                      }
                  } else {
                      if(axes.current[controlTypeSwitch] > ZERO_THRESHOLD){
                          onControlTypeChanged(false);
                          controlType.current = false;
                          axes.current[controlTypeSwitch] = gp.axes[controlTypeSwitch];
                      }
                  }*/
            let nextStatus = 0;
            if (gp.axes[armSwitch] > ZERO_THRESHOLD) {
                nextStatus = 1;
            }
            else if (gp.axes[armSwitch] < -ZERO_THRESHOLD) {
                nextStatus = -1;
            }
            if (nextStatus !== isArmed.current) {
                onArmedStatusChanged(nextStatus);
                isArmed.current = nextStatus;
            }
            axes.current[armSwitch] = gp.axes[armSwitch];
            if (isArmed.current > 0) {
                stickPositionsCb === null || stickPositionsCb === void 0 ? void 0 : stickPositionsCb(gp.axes);
                commandCounter.current++;
                turnCommandCounter.current++;
                const isRightPowerChannelChanged = Math.abs(axes.current[rightGasAxis] - gp.axes[rightGasAxis]) >
                    CHANGED_THRESHOLD ||
                    commandCounter.current >= COMMAND_REPEAT_THRESHOLD;
                const isTurnAxisDelta = Math.abs(axes.current[leftTurnAxis] - gp.axes[leftTurnAxis]) >
                    CHANGED_THRESHOLD;
                const isTurnCounterFired = turnCommandCounter.current >= COMMAND_REPEAT_THRESHOLD;
                const isTurnChannelChanged = isTurnAxisDelta || isTurnCounterFired;
                const isLeftPowerChannelChanged = Math.abs(axes.current[leftGasAxis] - gp.axes[leftGasAxis]) >
                    CHANGED_THRESHOLD;
                const isRightPowerChannelZero = Math.abs(gp.axes[rightGasAxis]) <= ZERO_THRESHOLD;
                const isTurnChannelZero = Math.abs(gp.axes[leftTurnAxis]) <= ZERO_THRESHOLD;
                const isLeftPowerChannelZero = Math.abs(gp.axes[leftGasAxis]) <= ZERO_THRESHOLD;
                if (!isRightPowerChannelZero) {
                    if (isRightPowerChannelChanged) {
                        //console.log(gp);
                        if (controlType.current) {
                            if (!isTurnChannelZero) {
                                if (gp.axes[leftTurnAxis] < 0) {
                                    turnCb(false, false, Math.abs(gp.axes[leftTurnAxis]), gp.axes[rightGasAxis]);
                                }
                                else {
                                    turnCb(true, false, Math.abs(gp.axes[leftTurnAxis]), gp.axes[rightGasAxis]);
                                }
                                isTurnStopping.current = false;
                                axes.current[leftTurnAxis] = gp.axes[leftTurnAxis];
                                axes.current[rightGasAxis] = gp.axes[rightGasAxis];
                                commandCounter.current = 0;
                                turnCommandCounter.current = 0;
                                return;
                            }
                            else {
                                if (isTurnStopping.current && lastTurnIsSpot.current) {
                                    isTurnStopping.current = false;
                                    turnCommandCounter.current = 0;
                                }
                                if (gp.axes[rightGasAxis] < 0) {
                                    goCb(Math.abs(gp.axes[rightGasAxis]), false);
                                }
                                else {
                                    goCb(gp.axes[rightGasAxis], true);
                                }
                            }
                        }
                        else {
                            if (gp.axes[rightGasAxis] < 0) {
                                rightBackwardCb(Math.abs(gp.axes[rightGasAxis]));
                            }
                            else {
                                rightForwardCb(gp.axes[rightGasAxis]);
                            }
                        }
                        axes.current[rightGasAxis] = gp.axes[rightGasAxis];
                    }
                }
                else {
                    if (Math.abs(axes.current[rightGasAxis]) > ZERO_THRESHOLD ||
                        (isRightPowerChannelChanged && isTurnChannelZero)) {
                        if (controlType.current) {
                            stopCb();
                        }
                        else {
                            rightStopCb();
                        }
                        axes.current[rightGasAxis] = gp.axes[rightGasAxis];
                    }
                }
                if (!isLeftPowerChannelZero) {
                    if (isLeftPowerChannelChanged) {
                        if (!controlType.current) {
                            if (gp.axes[leftGasAxis] < 0) {
                                leftBackwardCb(Math.abs(gp.axes[leftGasAxis]));
                            }
                            else {
                                leftForwardCb(gp.axes[leftGasAxis]);
                            }
                        }
                        axes.current[leftGasAxis] = gp.axes[leftGasAxis];
                    }
                }
                else {
                    if (Math.abs(axes.current[leftGasAxis]) > ZERO_THRESHOLD) {
                        if (!controlType.current) {
                            leftStopCb();
                        }
                        axes.current[leftGasAxis] = gp.axes[leftGasAxis];
                    }
                }
                if (controlType.current) {
                    const isSpot = isRightPowerChannelZero;
                    if (!isTurnChannelZero) {
                        if (
                        //(isSpot &&
                        isTurnChannelChanged) {
                            //|| (!isSpot && Math.abs(axes.current[leftTurnAxis]) < ZERO_THRESHOLD)) {
                            isTurnStopping.current = false;
                            if (gp.axes[leftTurnAxis] < 0) {
                                turnCb(false, isSpot, Math.abs(gp.axes[leftTurnAxis]), gp.axes[rightGasAxis]);
                            }
                            else {
                                turnCb(true, isSpot, Math.abs(gp.axes[leftTurnAxis]), gp.axes[rightGasAxis]);
                            }
                            axes.current[leftTurnAxis] = gp.axes[leftTurnAxis];
                        }
                    }
                    else {
                        if (Math.abs(axes.current[leftTurnAxis]) > ZERO_THRESHOLD) {
                            const endTurnPower = isSpot ? 0 : Math.abs(gp.axes[rightGasAxis]);
                            const dir = axes.current[leftTurnAxis] > 0;
                            if (dir) {
                                endTurnCb(true, isSpot, endTurnPower);
                            }
                            else {
                                endTurnCb(false, isSpot, endTurnPower);
                            }
                            isTurnStopping.current = true;
                            lastTurnDirection.current = dir;
                            lastTurnIsSpot.current = isSpot;
                            axes.current[leftTurnAxis] = gp.axes[leftTurnAxis];
                        }
                        else if (isTurnStopping.current && isTurnCounterFired) {
                            const endTurnPower = lastTurnIsSpot.current
                                ? 0
                                : Math.abs(gp.axes[rightGasAxis]);
                            endTurnCb(lastTurnDirection.current, lastTurnIsSpot.current, endTurnPower);
                        }
                    }
                }
                if (isRightPowerChannelChanged) {
                    commandCounter.current = 0;
                    axes.current[rightGasAxis] = gp.axes[rightGasAxis];
                }
                if (isLeftPowerChannelChanged) {
                    axes.current[leftGasAxis] = gp.axes[leftGasAxis];
                }
                if (isTurnChannelChanged) {
                    turnCommandCounter.current = 0;
                    axes.current[leftTurnAxis] = gp.axes[leftTurnAxis];
                }
                relaySwitches.forEach((swtch) => {
                    if (gp.axes[swtch] != axes.current[swtch]) {
                        onRelayStateChanged(swtch, gp.axes[swtch]);
                        axes.current[swtch] = gp.axes[swtch];
                    }
                });
            }
            //axes.current = [...gp.axes];
            /*if(gp.axes[relaySwitch1] != axes.current[relaySwitch1]) {
                      onRelayStateChanged(relaySwitch1, gp.axes[relaySwitch1]);
                      axes.current[relaySwitch1] = gp.axes[relaySwitch1];
                  }*/
        }
    }, [
        rightForwardCb,
        rightBackwardCb,
        leftForwardCb,
        leftBackwardCb,
        rightStopCb,
        leftStopCb,
        goCb,
        stopCb,
        turnCb,
        endTurnCb,
        onArmedStatusChanged,
        onControlTypeChanged,
        onRelayStateChanged,
        stickPositionsCb,
    ]);
    useEffect(() => {
        to.current = setInterval(pollGamepad, 40);
        return () => clearInterval(to.current);
    }, [pollGamepad]);
    /*useEffect(() => {
          setInterval(() => {
              const gamepads = navigator.getGamepads();
              console.log(gamepads);
          }, 1000);
      }, []);*/
    const onGamepadConnected = (event) => {
        //alert("Gamepad connected");
        console.log(`Gamepad connected: ${event.gamepad.id}`);
        //previousState = {}; // Сбрасываем состояние
        pollGamepad();
        if (!to.current) {
            to.current = setInterval(pollGamepad, 40);
        }
    };
    const onGamepadDisconnected = (event) => {
        console.log(`Gamepad disconnected: ${event.gamepad.id}`);
        if (isArmed.current > 0) {
            isArmed.current = 0;
            onArmedStatusChanged(0);
            axes.current = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        }
        if (to.current) {
            clearInterval(to.current);
            to.current = undefined;
        }
    };
    useEffect(() => {
        window.addEventListener("gamepadconnected", onGamepadConnected);
        return () => window.removeEventListener("gamepadconnected", onGamepadConnected);
    }, [onGamepadConnected]);
    useEffect(() => {
        window.addEventListener("gamepaddisconnected", onGamepadDisconnected);
        return () => window.removeEventListener("gamepaddisconnected", onGamepadDisconnected);
    }, [onGamepadDisconnected]);
    return _jsx(_Fragment, { children: children });
};
